/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Modal } from '@mairistem/composants';

interface AssistantModalSansPrenomProps {
  /** Numéros des partenaires sans prénom (1 et/ou 2) */
  partenaires: number[];
  /** Callback appelé lors de la validation de la modal */
  onValidate: () => void;
  /** Callback appelé lors de la fermeture de la modal */
  onClose: () => void;
}

/**
 * Avertit qu'un partenaire n'a pas de prénom (champ facultatif, cas d'une
 * personne sans prénom) avant de passer à l'étape suivante.
 */
const AssistantModalSansPrenom = (props: AssistantModalSansPrenomProps) => {
  const { partenaires, onValidate, onClose } = props;

  const concernes =
    partenaires.length > 1
      ? `les partenaires ${partenaires.join(' et ')}`
      : `le partenaire ${partenaires[0]}`;

  return (
    <Modal
      open
      closeIcon
      size="small"
      onClose={onClose}
      data-testid="assistant-modal-sans-prenom"
    >
      <Modal.Header>Aucun prénom saisi</Modal.Header>
      <Modal.Content>
        <span>
          Aucun prénom n&apos;a été saisi pour {concernes}, voulez-vous
          continuer ?
        </span>
      </Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="assistant-modal-sans-prenom-annuler"
          content="Annuler"
          icon="cancel"
          size="tiny"
          basic
          onClick={onClose}
        />
        <Button
          data-testid="assistant-modal-sans-prenom-continuer"
          content="Continuer"
          icon="check"
          positive
          onClick={onValidate}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default AssistantModalSansPrenom;
